export default __webpack_public_path__ + "static/media/django.972e3a45.svg";